import styled from '@emotion/styled'
import React, { useEffect, useState } from 'react'
import useRouteParam from '../../hooks/useRouteParam'
import BreakPoints from '../../styles/breakPoints'

const Wrapper = styled.div`
  position: sticky;
  top: 130px;

  #randomBanner,
  .download-bnr {
    margin: 0 auto;
    width: 300px;
    img {
      width: 300px;
    }

    a {
      margin: 0 auto;
      display: block;
      width: 300px;
    }
  }

  ${BreakPoints.large} {
  }
`

/**
 * コラム用サイドバーナレフル動線
 *
 * @constructor
 */
const ColumnKfSide = () => {
  const [no, setNo] = useState(-1)
  useEffect(() => {
    setNo(Math.floor(Math.random() * 6))
  }, [])

  const routeParam = useRouteParam(
    'https://www.knowleful.ai/?utm_source=kintaicloud&utm_medium=referral&utm_content=product-site'
  )
  const routeParam2 = useRouteParam(
    'https://www.knowleful.ai/?utm_source=kintaicloud&utm_medium=referral&utm_content=product-site'
  )
  const routeParam3 = useRouteParam(
    'https://www.knowleful.ai/?utm_source=kintaicloud&utm_medium=referral&utm_content=product-site'
  )
  const routeParam4 = useRouteParam(
    'https://www.knowleful.ai/?utm_source=kintaicloud&utm_medium=referral&utm_content=product-site'
  )
  const routeParam5 = useRouteParam(
    'https://www.knowleful.ai/?utm_source=kintaicloud&utm_medium=referral&utm_content=product-site'
  )
  const routeParam6 = useRouteParam(
    'https://www.knowleful.ai/?utm_source=kintaicloud&utm_medium=referral&utm_content=product-site'
  )

  return (
    <Wrapper>
      {no === 0 && (
        <div id="randomBanner">
          <a href={routeParam} target="_blank" rel="noreferrer">
            <img
              src="/images/column/common/sideKfBanner001.png"
              alt="キンクラの導入効果"
            />
            法人向け生成AIツール「ナレフルチャット」
          </a>
        </div>
      )}
      {no === 1 && (
        <div id="randomBanner">
          <a href={routeParam2} target="_blank" rel="noreferrer">
            <img
              src="/images/column/common/sideKfBanner002.png"
              alt="キンクラの導入効果"
            />
            法人向け生成AIツール「ナレフルチャット」
          </a>
        </div>
      )}
      {no === 2 && (
        <div id="randomBanner">
          <a href={routeParam3} target="_blank" rel="noreferrer">
            <img
              src="/images/column/common/sideKfBanner003.png"
              alt="キンクラの導入効果"
            />
            法人向け生成AIツール「ナレフルチャット」
          </a>
        </div>
      )}
      {no === 3 && (
        <div id="randomBanner">
          <a href={routeParam4} target="_blank" rel="noreferrer">
            <img
              src="/images/column/common/sideKfBanner004.png"
              alt="キンクラの導入効果"
            />
            法人向け生成AIツール「ナレフルチャット」
          </a>
        </div>
      )}
      {no === 4 && (
        <div id="randomBanner">
          <a href={routeParam5} target="_blank" rel="noreferrer">
            <img
              src="/images/column/common/sideKfBanner005.png"
              alt="キンクラの導入効果"
            />
            法人向け生成AIツール「ナレフルチャット」
          </a>
        </div>
      )}
      {no === 5 && (
        <div id="randomBanner">
          <a href={routeParam6} target="_blank" rel="noreferrer">
            <img
              src="/images/column/common/sideKfBanner006.png"
              alt="キンクラの導入効果"
            />
            法人向け生成AIツール「ナレフルチャット」
          </a>
        </div>
      )}
    </Wrapper>
  )
}
export default ColumnKfSide
